import type {
    CommerceRuntimeDiagnostics,
    CommerceRuntimeInitializationStage,
    CommerceRuntimeInitializationStageName,
} from "@teqtank/commerce-contracts";

export class RuntimeBootstrapRecorder {
    private readonly startedAt = getCurrentMilliseconds();
    private readonly stages: CommerceRuntimeInitializationStage[] = [];

    public constructor(private readonly correlationId: string) {}

    public async measure<T>(
        name: CommerceRuntimeInitializationStageName,
        action: () => T | Promise<T>,
    ): Promise<T> {
        const stageStartedAt = getCurrentMilliseconds();

        try {
            return await action();
        } finally {
            this.stages.push(
                Object.freeze({
                    name,

                    durationMilliseconds: roundMilliseconds(
                        getCurrentMilliseconds() - stageStartedAt,
                    ),
                }),
            );
        }
    }

    public createDiagnostics(transportName: string): CommerceRuntimeDiagnostics {
        return Object.freeze({
            initializedAt: new Date(),

            initializationDurationMilliseconds: roundMilliseconds(
                getCurrentMilliseconds() - this.startedAt,
            ),

            transportName,
            correlationId: this.correlationId,
            stages: Object.freeze([...this.stages]),
        });
    }
}

function getCurrentMilliseconds(): number {
    if (typeof globalThis.performance?.now === "function") {
        return globalThis.performance.now();
    }

    return Date.now();
}

function roundMilliseconds(value: number): number {
    return Math.round(value * 1000) / 1000;
}
